import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledWrapper, StyledButton, IconButton  } from './NavigationSearch.styles';
import { SearchBar } from '../../atoms/SearchBar/SearchBar';
import { FaSearch } from 'react-icons/fa';
import {
  useIsDesktopOrLaptop,
  useIsMiniNotebook,
  useIsMobileBig,
  useIsMobileMedium,
  useIsMobileMini
} from '../../../styles/theme';

interface NavigationSearchProps {
  onSearch: (tag: string) => void; // Prop para enviar o valor da busca
}

export const NavigationSearch: React.FC<NavigationSearchProps> = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const isDesktopOrLaptop = useIsDesktopOrLaptop();
  const isMiniNotebook = useIsMiniNotebook();
  const isMobileBig = useIsMobileBig();
  const isMobileMedium = useIsMobileMedium();
  const isMobileMini = useIsMobileMini();

  const handleSearch = () => {
    if (searchValue.trim() !== '') {
      navigate(`/?q=${encodeURIComponent(searchValue)}`);
    }
  };

  return (
    <StyledWrapper
    isDesktopOrLaptop={isDesktopOrLaptop}
    isMiniNotebook={isMiniNotebook}
    isMobileBig={isMobileBig}
    isMobileMedium={isMobileMedium}
    isMobileMini={isMobileMini}>
      <SearchBar
      value={searchValue} 
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder="Digite..." />
      
      {/* Se for tela pequena (isMobileMini), mostra o ícone em vez do botão */}
      {isMobileMini ? (
        <IconButton onClick={handleSearch}>
          <FaSearch size={11} /> {/* Ícone de busca */}
        </IconButton>
      ) : (
        <StyledButton
          isDesktopOrLaptop={isDesktopOrLaptop}
          isMiniNotebook={isMiniNotebook}
          isMobileBig={isMobileBig}
          isMobileMedium={isMobileMedium}
          isMobileMini={isMobileMini}
          onClick={handleSearch}
        >
          Buscar
        </StyledButton>
      )}
    </StyledWrapper>
  );
};